<template>
	<v-form ref="f" v-model="valid">
		<v-container>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline ">Daily Revenue Report</v-card-title>
						<v-container class="px-5" >
							<v-row >
								<v-col class="pb-0" cols="6" >
									<a-hotel-select v-model="form.hotelCode"
											  	 :hotels="hotels"
											  	 :loading="preLoading"
											  	 @change="changeHotel">
									</a-hotel-select>
								</v-col>
								<v-col class="pb-0" cols="6" >
									<v-menu v-model="dateMenu"
											:close-on-content-click="false"
											:nudge-right="40"
											:disabled="!allowDatePick"
											transition="scale-transition"
											offset-y
											min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field v-model="form.reportDate"
														  label="Дата отчета"
														  :loading="preLoading"
														  prepend-icon="event"
														  :rules="[v => !!v || 'Укажите дату']"
														  readonly
														  v-on="on">
											</v-text-field>
										</template>
										<v-date-picker v-model="form.reportDate"
													   @input="dateMenu = false"
													   :landscape="true"
				   									   :reactive="true"
				   									   scrollable
				   									   first-day-of-week="1"
				   									   locale="ru-ru"
				   									   :show-current="false"
													   :max="yesterday">
										</v-date-picker>
									</v-menu>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline ">Rooms</v-card-title>
						<v-container class="px-5" >
							<v-row >
								<v-col class="pb-0" >
									<a-number-field label="Direct Revenue"
												 v-model="form.directRev">
									</a-number-field>
								</v-col>
								<v-col class="pb-0" >
									<a-number-field label="Direct Rooms Sold"
												 v-model="form.directSold"
												 :rules="[v => !form.directRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="OTA Revenue"
												 v-model="form.otaRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="OTA Rooms Sold"
												 v-model="form.otaSold"
												 :rules="[v => !form.otaRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Wholesale Revenue"
												 v-model="form.wholesaleRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Wholesale Rooms Sold"
												 v-model="form.wholesaleSold"
												 :rules="[v => !form.wholesaleRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Group Revenue"
												 v-model="form.groupRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Group Rooms Sold"
												 v-model="form.groupSold"
												 :rules="[v => !form.groupRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Travel Agent Revenue"
												 v-model="form.taRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Travel Agent Rooms Sold"
												 v-model="form.taSold"
												 :rules="[v => !form.taRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Negotiated Revenue"
												 v-model="form.negRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Negotiated Rooms Sold"
												 v-model="form.negSold"
												 :rules="[v => !form.negRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Other Rooms Revenue"
												 v-model="form.otherRoom">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row  justify="end">
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Complimentary & House Use Rooms Occupied"
												 v-model="form.compRooms">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Total Room Revenue, RUB"
												 v-model="total.roomRev"
												 prepend-icon="functions"
												 readonly>
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Total Rooms Occupied"
												 v-model="total.roomsSold"
												 prepend-icon="functions"
												 readonly>
							  		</a-number-field>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline">Food & Beverage</v-card-title>
						<v-container class="px-5" >
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Breakfast Revenue"
												 v-model="form.breakfastRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Breakfast Covers"
												 v-model="form.breakfastCov"
												 :rules="[v => !form.breakfastRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest1"
												 :label="outlets.rest1 + ' Revenue'"
												 v-model="form.rest1Rev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest1"
												 :label="outlets.rest1 + ' Covers'"
												 v-model="form.rest1Cov"
												 :rules="[v => !form.rest1Rev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest2"
												 :label="outlets.rest2 + ' Revenue'"
												 v-model="form.rest2Rev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest2"
												 :label="outlets.rest2 + ' Covers'"
												 v-model="form.rest2Cov"
												 :rules="[v => !form.rest2Rev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest3"
												 :label="outlets.rest3 + ' Revenue'"
												 v-model="form.rest3Rev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest3"
												 :label="outlets.rest3 + ' Covers'"
												 v-model="form.rest3Cov"
												 :rules="[v => !form.rest3Rev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest4"
												 :label="outlets.rest4 + ' Revenue'"
												 v-model="form.rest4Rev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest4"
												 :label="outlets.rest4 + ' Covers'"
												 v-model="form.rest4Cov"
												 :rules="[v => !form.rest4Rev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest5"
												 :label="outlets.rest5 + ' Revenue'"
												 v-model="form.rest5Rev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.rest5"
												 :label="outlets.rest5 + ' Covers'"
												 v-model="form.rest5Cov"
												 :rules="[v => !form.rest5Rev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.lobby"
												 :label="outlets.lobby + ' Revenue'"
												 v-model="form.lobbyRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.lobby"
												 :label="outlets.lobby + ' Covers'"
												 v-model="form.lobbyCov"
												 :rules="[v => !form.lobbyRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.lounge"
												 :label="outlets.lounge + ' Revenue'"
												 v-model="form.loungeRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field v-if="outlets.lounge"
												 :label="outlets.lounge + ' Covers'"
												 v-model="form.loungeCov"
												 :rules="[v => !form.loungeRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Banquet Revenue"
												 v-model="form.banqRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Banquet Covers"
												 v-model="form.banqCov"
												 :rules="[v => !form.banqRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Room Service Revenue"
												 v-model="form.rsRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Room Service Covers"
												 v-model="form.rsCov"
												 :rules="[v => !form.rsRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Minibar Revenue"
												 v-model="form.minibarRev">
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Minibar Covers"
												 v-model="form.minibarCov"
												 :rules="[v => !form.minibarRev || !!v || 'Введите количество проданных номеров']">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Other F&B Revenue"
												 v-model="form.otherFb">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Total F&B Revenue, RUB"
												 v-model="total.fbRev"
												 prepend-icon="functions"
												 readonly>
							  		</a-number-field>
								</v-col>
								<v-col class="pb-0 pt-0" >
									<a-number-field label="Total F&B Covers"
												 v-model="total.fbCov"
												 prepend-icon="functions"
												 readonly>
							  		</a-number-field>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline">Other Revenue</v-card-title>
						<v-container class="px-5" >
							<v-card-subtitle class="pl-0 pb-1 font-weight-bold">Other Operated Departments</v-card-subtitle>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Laundry"
												 v-model="form.laundryRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Wellness"
												 v-model="form.wellnessRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Transportation"
												 v-model="form.transpRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Shop"
												 v-model="form.shopRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Parking"
												 v-model="form.parkingRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Other"
												 v-model="form.oodOtherRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-card-subtitle class="pl-0 pb-1 font-weight-bold">Miscellaneous Income</v-card-subtitle>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Cancellation Fee"
												 v-model="form.cancellationFeeRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Hotel Damage"
												 v-model="form.hotelDamageRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Rentals"
												 v-model="form.rentalsRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Other Income"
												 v-model="form.otherRev">
							  		</a-number-field>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="Total Other Revenue, RUB"
												 v-model="total.otherRev"
												 prepend-icon="functions"
												 readonly>
							  		</a-number-field>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline">Total Operating Revenue</v-card-title>
						<v-container class="px-5" >
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field label="RUB"
												 v-model="totalRev.total"
												 prepend-icon="functions"
												 readonly>
							  		</a-number-field>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline">10 Days Forecast</v-card-title>
						<v-container class="px-5">
							<v-row v-for="(day, i) in days" :key="i">
								<v-col class="pb-0 pt-0" cols="12" sm="6" >
									<a-number-field :label="day"
												 v-model="form.fcst.day[i]"
												 suffix="%"
												 :rules="[v => !!v || 'Введите прогноз',
												 		  v => (v >= 0 && v <= 110) || 'Введите число от 0 до 110']">
							  		</a-number-field>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline">3 Months Forecast</v-card-title>
						<v-container class="px-5">
							<template v-for="(month, i) in months">
								<v-row v-if="i < 3" :key="i">
									<v-col class="pb-0 pt-0" cols="12" sm="6" >
										<a-number-field
											:label="month"
											v-model="form.fcst.month[i]"
											suffix="%"
											:rules="[
												v => !!v || 'Введите прогноз',
												v => (v >= 0 && v <= 110) || 'Введите число от 0 до 110'
												]"
										></a-number-field>
									</v-col>
								</v-row>
							</template>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline">Comments and files</v-card-title>
						<v-container class="px-5" >
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" >
									<v-textarea
										label="Comments"
										auto-grow
										autocomplete="off"
										:rules="[v => v.length <= 700 || 'Ограничение длины комментария - 700 символов.']"
										v-model="form.comments">
							  		</v-textarea>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" >
									<a-file-picker
										v-model="manFlash"
										:label="'Manager flash, ' + reportDateShort"
										hint="Month to Date, Revenue Net"
										ref="manFlash"
										formats="pdf"
										maxSize="3"
										required>
									</a-file-picker>
								</v-col>
							</v-row>
							<v-row v-for="(month, i) in months" :key="i">
								<v-col class="pb-0 pt-0" cols="12" >
									<a-file-picker
										v-model="histFcst[i]"
										:label="'History & Forecast, ' + month"
										hint="Room Revenue Net"
										ref="histFcst"
										formats="pdf"
										maxSize="3"
										required>
									</a-file-picker>
								</v-col>
							</v-row>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" >
									<a-file-picker
										v-model="otherAttachments"
										label="Other attachments"
										multiple
										ref="otherAttachments"
										formats="pdf">
									</a-file-picker>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-container class="px-5" >
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" >
									<v-btn color="primary"
										   @click="validateForm">
										Отправить
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<v-dialog v-model="dialogConfirm"
      			  max-width="80%">
			<v-card>
		  		<v-card-title class="headline">
					Проверьте данные
				</v-card-title>

		        <v-card-text>
					<v-container fluid>
						<v-row >
							<v-col cols="12">
								<v-row >
									<v-col cols="12">
										<v-row >
											<v-col class="pb-0" cols="6" >
												<v-text-field label="Отель"
															  v-model="form.hotelCode"
															  prepend-icon="domain"
															  readonly>
												</v-text-field>
											</v-col>
											<v-col class="pb-0" cols="6" >
												<v-text-field label="Дата отчета"
															  v-model="form.reportDate"
															  prepend-icon="event"
															  readonly>
												</v-text-field>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="4">
								<v-row>
									<v-col cols="12" class="subtitle-1">
										Выручка
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Выручка номерного фонда"
													 v-model="total.roomRev"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Выручка службы питания"
													 v-model="total.fbRev"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Другая выручка"
													 v-model="total.otherRev"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Итого выручка"
													 v-model="totalRev.total"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="4">
								<v-row>
									<v-col cols="12" class="subtitle-1">
										ADR
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR Direct"
													 v-model="adr.direct"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR OTA"
													 v-model="adr.ota"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR Wholesale"
													 v-model="adr.wholesale"
													 suffix="руб."
													 v-if="adr.wholesale"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR Group"
													 v-model="adr.group"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR Travel Agent"
													 v-model="adr.ta"
													 suffix="руб."
													 v-if="adr.ta"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR Negotiated"
													 v-model="adr.neg"
													 suffix="руб."
													 v-if="adr.neg"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="ADR Total"
													 v-model="adr.total"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="4">
								<v-row>
									<v-col cols="12" class="subtitle-1">
										Средний чек
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Average Check Breakfast"
													 v-model="avCheck.breakfast"
													 suffix="руб."
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.rest1"
													 v-model="avCheck.rest1"
													 suffix="руб."
													 v-if="avCheck.rest1"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.rest2"
													 v-model="avCheck.rest2"
													 suffix="руб."
													 v-if="+avCheck.rest2"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.rest3"
													 v-model="avCheck.rest3"
													 suffix="руб."
													 v-if="+avCheck.rest3"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.rest4"
													 v-model="avCheck.rest4"
													 suffix="руб."
													 v-if="+avCheck.rest4"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.rest5"
													 v-model="avCheck.rest5"
													 suffix="руб."
													 v-if="+avCheck.rest5"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.lobby"
													 v-model="avCheck.lobby"
													 suffix="руб."
													 v-if="avCheck.lobby"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field :label="'Average Check ' + outlets.lounge"
													 v-model="avCheck.lounge"
													 suffix="руб."
													 v-if="avCheck.lounge"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Average Check Banqueting"
													 v-model="avCheck.banq"
													 suffix="руб."
													 v-if="avCheck.banq"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Average Check Room Service"
													 v-model="avCheck.rs"
													 suffix="руб."
													 v-if="avCheck.rs"
													 readonly>
										</a-number-field>
									</v-col>
									<v-col class="pb-0 pt-0" cols="12" >
										<a-number-field label="Average Check Minibar"
													 v-model="avCheck.minibar"
													 suffix="руб."
													 v-if="avCheck.minibar"
													 readonly>
										</a-number-field>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-container>
					<v-btn class="ma-2" color="primary" @click="sendReport">
						Все верно
					</v-btn>
					<v-btn class="ma-2" color="secondary" @click="dialogConfirm = false">
						Назад
					</v-btn>
		        </v-card-text>
	      	</v-card>
		</v-dialog>
	</v-form>
</template>


<script>
	import aFilePicker from '../base/AFilePicker.vue'
	import aNumberField from '../base/ANumberField.vue'
	import aHotelSelect from '../base/AHotelSelect.vue'
	import {api} from '../../lib/api'
	import {getMonthName, toNum, toStr, sumFormat, randomString} from '../../js/common.js'

	export default {
		components: {
			aFilePicker,
			aNumberField,
			aHotelSelect
		},
		data: () => ({
			form: {
				reportDate: '',
				hotelCode: '',
				directRev: '',
				directSold: '',
				otaRev: '',
				otaSold: '',
				wholesaleRev: '',
				wholesaleSold: '',
				groupRev: '',
				groupSold: '',
				taRev: '',
				taSold: '',
				negRev: '',
				negSold: '',
				otherRoom: '',
				compRooms: '',
				breakfastRev: '',
				breakfastCov: '',
				rest1Rev: '',
				rest1Cov: '',
				rest2Rev: '',
				rest2Cov: '',
				rest3Rev: '',
				rest3Cov: '',
				rest4Rev: '',
				rest4Cov: '',
				rest5Rev: '',
				rest5Cov: '',
				lobbyRev: '',
				lobbyCov: '',
				loungeRev: '',
				loungeCov: '',
				banqRev: '',
				banqCov: '',
				rsRev: '',
				rsCov: '',
				minibarRev: '',
				minibarCov: '',
				otherFb: '',
				telecomRev: '',
				laundryRev: '',
				wellnessRev: '',
				payTvRev: '',
				transpRev: '',
				shopRev: '',
				parkingRev: '',
				oodOtherRev: '',
				cancellationFeeRev: '',
				hotelDamageRev: '',
				rentalsRev: '',
				otherRev: '',
				fcst: {
					day: ['', '', '', '', '', '', '', '', '', ''],
					month: ['', '', '']
				},
				comments: '',
			},
			hotels: null,
			preLoading: true,
			dialogConfirm: false,
			dateMenu: false,
			valid: false,
			manFlash: [],
			histFcst: [ [], [], [], [] ],
			otherAttachments: [],
			debug: false,
			timer: 0,
			updateInterval: 3600000, // 1 час
		}),
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			if (this.debug) this.fillRandom()

			// this.form.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
			// this.hotelCode = 'TEST'

			this.apiFirstCall()

			this.timer = setInterval(() => {
				if (!document.hidden) {
					this.apiFirstCall()
				}
			}, this.updateInterval)
		},
		destroyed() {
			clearInterval(this.timer)
		},
		computed: {
			outlets() {
				return this.selectedHotel ? this.selectedHotel.outlets : {
					rest1: '',
					rest2: '',
					rest3: '',
					rest4: '',
					rest5: '',
					lobby: '',
					lounge: ''
				}
			},
			total() {
				return {
					roomRev: sumFormat([
						this.form.directRev,
						this.form.otaRev,
						this.form.wholesaleRev,
						this.form.groupRev,
						this.form.taRev,
						this.form.negRev,
						this.form.otherRoom
					]),
					roomsSold: sumFormat([
						this.form.directSold,
						this.form.otaSold,
						this.form.wholesaleSold,
						this.form.groupSold,
						this.form.taSold,
						this.form.negSold,
						this.form.compRooms
					]),
					fbRev: sumFormat([
						this.form.breakfastRev,
						this.form.rest1Rev,
						this.form.rest2Rev,
						this.form.rest3Rev,
						this.form.rest4Rev,
						this.form.rest5Rev,
						this.form.lobbyRev,
						this.form.loungeRev,
						this.form.banqRev,
						this.form.rsRev,
						this.form.minibarRev,
						this.form.otherFb
					]),
					fbCov: sumFormat([
						this.form.breakfastCov,
						this.form.rest1Cov,
						this.form.rest2Cov,
						this.form.rest3Cov,
						this.form.rest4Cov,
						this.form.rest5Cov,
						this.form.lobbyCov,
						this.form.loungeCov,
						this.form.banqCov,
						this.form.rsCov,
						this.form.minibarCov
					]),
					otherRev: sumFormat([
						this.form.telecomRev,
						this.form.laundryRev,
						this.form.wellnessRev,
						this.form.payTvRev,
						this.form.transpRev,
						this.form.shopRev,
						this.form.parkingRev,
						this.form.oodOtherRev,
						this.form.cancellationFeeRev,
						this.form.hotelDamageRev,
						this.form.rentalsRev,
						this.form.otherRev
					]),
				}
			},
			totalRev() {
				return {
					total: sumFormat([
						this.total.roomRev,
						this.total.fbRev,
						this.total.otherRev
					])
				}
			},
			adr() {
				return {
					direct: toStr(toNum(this.form.directRev) / toNum(this.form.directSold)) || 0,
					ota: toStr(toNum(this.form.otaRev) / toNum(this.form.otaSold)) || 0,
					wholesale: toStr(toNum(this.form.wholesaleRev) / toNum(this.form.wholesaleSold)) || 0,
					group: toStr(toNum(this.form.groupRev) / toNum(this.form.groupSold)) || 0,
					ta: toStr(toNum(this.form.taRev) / toNum(this.form.taSold)) || 0,
					neg: toStr(toNum(this.form.negRev) / toNum(this.form.negSold)) || 0,
					total: toStr(toNum(this.total.roomRev) / (toNum(this.total.roomsSold) - toNum(this.form.compRooms))) || 0
				}
			},
			avCheck() {
				return {
					breakfast: toStr(toNum(this.form.breakfastRev) / toNum(this.form.breakfastCov)) || 0,
					rest1: toStr(toNum(this.form.rest1Rev) / toNum(this.form.rest1Cov)) || 0,
					rest2: toStr(toNum(this.form.rest2Rev) / toNum(this.form.rest2Cov)) || 0,
					rest3: toStr(toNum(this.form.rest3Rev) / toNum(this.form.rest3Cov)) || 0,
					rest4: toStr(toNum(this.form.rest4Rev) / toNum(this.form.rest4Cov)) || 0,
					rest5: toStr(toNum(this.form.rest5Rev) / toNum(this.form.rest5Cov)) || 0,
					lobby: toStr(toNum(this.form.lobbyRev) / toNum(this.form.lobbyCov)) || 0,
					lounge: toStr(toNum(this.form.loungeRev) / toNum(this.form.loungeCov)) || 0,
					banq: toStr(toNum(this.form.banqRev) / toNum(this.form.banqCov)) || 0,
					rs: toStr(toNum(this.form.rsRev) / toNum(this.form.rsCov)) || 0,
					minibar: toStr(toNum(this.form.minibarRev) / toNum(this.form.minibarCov)) || 0
				}
			},
			reportDateShort() {
				if (!this.form.reportDate) return ''
				else {
					let d = new Date(this.form.reportDate)
					return (d.getDate() + ' ' + getMonthName(d.getMonth() + 1, 'R'))
				}
			},
			selectedHotel() {
				let i = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.form.hotelCode)
				return this.hotels[i]
			},
			allowDatePick() {
				if (!this.selectedHotel) return false
				else return this.selectedHotel.allowDatePick
			},
			yesterday() {
				let y = new Date()
				y.setDate(y.getDate() - 1)
				return y.toISOString().substr(0, 10)
			},
			days() {
				if (!this.form.reportDate) return null

				let d = new Date(this.form.reportDate)
				let output = []

				for (let i = 0; i < 10; i++) {
					d.setDate(d.getDate() + 1)
					output.push(d.getDate() + ' ' + getMonthName(d.getMonth() + 1, 'R'))
				}
				return output
			},
			months() {
				if (!this.form.reportDate) return null

				let d = new Date(this.form.reportDate)
				let output = []

				for (let i = 0; i < 4; i++) {
					let name = getMonthName(d.getMonth() + 1, 'Ul')
					output.push(name)
					d.setMonth(d.getMonth() + 1, 1)
				}
				return output
			},
		},
		methods: {
			apiFirstCall: function () {
				// console.log('apiFirstCall')
				api.all([
					api.post('drr/get_last_report_date', { hotels: this.hotels }),
					api.post('common/get_hotel_outlets', { hotels: this.hotels })
				])
				.then(api.spread((responseD, responseO) => {
					this.hotels = responseD.data.hotels
					this.hotels.forEach((hotel, key) => {
						hotel.outlets = responseO.data.hotels[key].outlets
						if (hotel.maxDate) {
							let d = new Date(hotel.maxDate)
							d.setDate(d.getDate() + 1)
							hotel.reportDate = d.toISOString().substr(0, 10)
							hotel.allowDatePick = false
						}
						else {
							hotel.reportDate = ''
							hotel.allowDatePick = true
						}
					})
					if (!this.form.hotelCode) {
						this.form.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
						// this.form.hotelCode = 'TSET'
						this.changeHotel()
					}

					this.preLoading = false

					// this.fillRandom()

				}), error => {})
			},
			validateForm: function () {
				let v = this.$refs.f.validate()
				if (v) {
					this.dialogConfirm = true
				}
			},
			sendReport: function () {
				var formData = new FormData()
				formData.append('form', JSON.stringify(this.form))

				formData.append('manFlash', this.manFlash[0])

				for (let i = 0; i < 4; i++) {
					formData.append('histFcst[]', this.histFcst[i][0])
				}

				let l = this.otherAttachments.length
				for (let i = 0; i < l; i++) {
					formData.append('otherAttachments[]', this.otherAttachments[i])
				}

				api.post('drr/send_report', formData)
				.then(response => {
					for(let key in this.form) {
						if (key == 'fcst') {
							this.form[key] = {
								day: ['', '', '', '', '', '', '', '', '', ''],
								month: ['', '', '']
							}
						}
						else if (key != 'hotel' || key != 'reportDate') {
							this.form[key] = ''
						}
					}

					this.manFlash = []
					for (let i = 0; i < 4; i++) {
						this.histFcst[i] = []
					}
					this.otherAttachments = []

					this.apiFirstCall()

					this.$refs.f.resetValidation()

					this.dialogConfirm = false
					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
				}, error => {})
				this.$store.dispatch('dialogLoadingStart')
			},
			changeHotel: function (hotelCode) {
				this.form.reportDate = this.selectedHotel.reportDate
			},
			fillRandom: function () {
				this.form.directRev = toStr(Math.random() * 100000)
				this.form.directSold = toStr(Math.random() * 100)
				this.form.otaRev = toStr(Math.random() * 100000)
				this.form.otaSold = toStr(Math.random() * 100)
				this.form.wholesaleRev = toStr(Math.random() * 100000)
				this.form.wholesaleSold = toStr(Math.random() * 100)
				this.form.groupRev = toStr(Math.random() * 100000)
				this.form.groupSold = toStr(Math.random() * 100)
				this.form.taRev = toStr(Math.random() * 100000)
				this.form.taSold = toStr(Math.random() * 100)
				this.form.negRev = toStr(Math.random() * 100000)
				this.form.negSold = toStr(Math.random() * 1000)
				this.form.otherRoom = toStr(Math.random() * 100000)
				this.form.compRooms = toStr(Math.random() * 100)
				this.form.breakfastRev = toStr(Math.random() * 100000)
				this.form.breakfastCov = toStr(Math.random() * 100)
				this.form.rest1Rev = toStr(Math.random() * 100000)
				this.form.rest1Cov = toStr(Math.random() * 100)
				// this.form.rest2Rev = toStr(Math.random() * 100000)
				// this.form.rest2Cov = toStr(Math.random() * 100)
				// this.form.rest3Rev = toStr(Math.random() * 100000)
				// this.form.rest3Cov = toStr(Math.random() * 100)
				// this.form.rest4Rev = toStr(Math.random() * 100000)
				// this.form.rest4Cov = toStr(Math.random() * 100)
				// this.form.rest5Rev = toStr(Math.random() * 100000)
				// this.form.rest5Cov = toStr(Math.random() * 100)
				this.form.lobbyRev = toStr(Math.random() * 100000)
				this.form.lobbyCov = toStr(Math.random() * 100)
				this.form.loungeRev = toStr(Math.random() * 100000)
				this.form.loungeCov = toStr(Math.random() * 100)
				this.form.banqRev = toStr(Math.random() * 100000)
				this.form.banqCov = toStr(Math.random() * 100)
				this.form.rsRev = toStr(Math.random() * 100000)
				this.form.rsCov = toStr(Math.random() * 100)
				this.form.minibarRev = toStr(Math.random() * 100000)
				this.form.minibarCov = toStr(Math.random() * 100)
				this.form.otherFb = toStr(Math.random() * 10000)
				this.form.telecomRev = toStr(Math.random() * 10000)
				this.form.laundryRev = toStr(Math.random() * 10000)
				this.form.wellnessRev = toStr(Math.random() * 10000)
				this.form.payTvRev = toStr(Math.random() * 10000)
				this.form.transpRev = toStr(Math.random() * 10000)
				this.form.shopRev = toStr(Math.random() * 10000)
				this.form.parkingRev = toStr(Math.random() * 10000)
				this.form.oodOtherRev = toStr(Math.random() * 10000)
				this.form.cancellationFeeRev = toStr(Math.random() * 10000)
				this.form.hotelDamageRev = toStr(Math.random() * 10000)
				this.form.rentalsRev = toStr(Math.random() * 10000)
				this.form.otherRev = toStr(Math.random() * 10000)

				this.form.comments = randomString(100)

				for (let i = 0; i < 10; i++) {
					this.form.fcst.day[i] = toStr(Math.random() * 100)
				}
				for (let i = 0; i < 3; i++) {
					this.form.fcst.month[i] = toStr(Math.random() * 100)
				}
			},
		}
	}
</script>
